import { usePrices } from "@/contexts/prices-provider";
import {
  TeamInvitationDTO,
  TeamLicenseInventoryDTO,
  TeamUserDTO,
} from "@shaarp/common";
import { useEffect, useMemo } from "react";
import { DataTable } from "../data-table/data-table";
import {
  TeamMemberRow,
  dataTableTeamMembersColumns,
} from "./data-table-team-members-columns";

interface DataTableTeamMembersProps {
  users: TeamUserDTO[];
  invitations: TeamInvitationDTO[];
  isLoading: boolean;
  inventory?: TeamLicenseInventoryDTO;
  onInventoryRefetch?: () => Promise<void>;
}

export default function DataTableTeamMembers({
  users,
  invitations,
  isLoading,
  inventory,
  onInventoryRefetch,
}: DataTableTeamMembersProps) {
  const { apiFetchPrices } = usePrices();

  useEffect(() => {
    apiFetchPrices();
  }, []);

  const rows: TeamMemberRow[] = useMemo(() => {
    const userRows: TeamMemberRow[] = users.map((user) => ({
      kind: "user",
      id: `user-${user.id}`,
      email: user.email,
      fullName: user.fullName,
      role: user.role,
      priceId: user.priceId || null,
      user,
    }));
    const invitationRows: TeamMemberRow[] = invitations.map((invitation) => ({
      kind: "invitation",
      id: `invitation-${invitation.id}`,
      email: invitation.email,
      fullName: invitation.email,
      role: invitation.role,
      priceId: invitation.priceId,
      invitation,
    }));
    return [...userRows, ...invitationRows];
  }, [users, invitations]);

  return (
    <DataTable
      data={rows}
      columns={dataTableTeamMembersColumns(inventory, onInventoryRefetch)}
      isLoading={isLoading}
    />
  );
}
